/**
 * ProHabbo
 *
 * Henrique Arthur <eu@henriquearthur.com.br>
 */

 CreateTopic = {
    preview: function() {
        var form = $(".create-topic-form");

        var content = form.find('textarea[name="content"]').val();

        if (content == '') {
            form.effect('shake', { distance: 3 });
        } else {
            $.ajax({
                url: '/a/createTopic/preview',
                type: 'POST',
                dataType: 'json',
                data: {'content': content},
            }).done(function(data) {
                $(".forum-topic-preview-area").html(data.html);
            });
        }
    },
    init: function() {
        $(".forum-preview-topic").on('click', CreateTopic.preview);
    }
};
